import React from "react";
import { Container } from "./styles";
import HeadBanner from "../../components/sections/HeadBanner";
import TradeInfo from "../../components/sections/TradeInfo";
import CoinPrices from "../../components/sections/CoinPrices";
import SwapLiquidity from "../../components/sections/SwapLiquidity";
import BuyPay from "../../components/sections/BuyPay";
import Features from "../../components/sections/Features";
import Join from "../../components/sections/Join";
import Footer from "../../components/sections/Footer";
import background from "../../assets/images/background.png";
import FirstSection from "../../components/sections/FirstSection";
import AboutUs from "../../components/sections/AboutUs";
import RoadmapSlicker from "../../components/RoadmapSlicker";
import Partners from "../../components/sections/Partners";
import Tokenomics from "../../components/sections/Tokenomics";
const Home = () => {
  return (
    <Container>
      {/* <img src={background} alt="" className="background-home" /> */}
      <FirstSection />
      {/* <HeadBanner/> */}
      {/* <CoinPrices /> */}
      <AboutUs />
      <Tokenomics />
      {/* <SwapLiquidity /> */}
      {/* <TradeInfo /> */}
      {/* <BuyPay /> */}
      {/* <Features /> */}
      <RoadmapSlicker />
      <Partners />
      {/* <Join /> */}
      <Footer />
    </Container>
  );
};

export default Home;
